/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsFeedActivityRequest } from '../../models/news-feed-activity-request';
import { NewsFeedListResponse } from '../../models/news-feed-list-response';

export interface AddNewsFeedActivityToNewsFeed$Params {
  
    /**
     * NewsFeed item to create
     */
    body: NewsFeedActivityRequest
}

export function addNewsFeedActivityToNewsFeed(http: HttpClient, rootUrl: string, params: AddNewsFeedActivityToNewsFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListResponse>> {
  const rb = new RequestBuilder(rootUrl, addNewsFeedActivityToNewsFeed.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsFeedListResponse>;
    })
  );
}

addNewsFeedActivityToNewsFeed.PATH = '/rest/newsfeed/activity';
